import { default as evaluation } from ":src/modules/grading/evaluation/routes";
import { default as help } from ":src/modules/help-center/routes";
import { default as profile } from ":src/modules/profile/routes";
export default {
  BASE: "/evaluator",
  evaluation,
  help,
  profile,
};
